<template>
  <router-view />
</template>

<style lang="scss">
#app {
  font-family: "Neue Plak", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--blue);
}
html,
body {
  padding: 0;
  margin: 0;
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: var(--darker-blue);
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--blue);
  }
}
:root {
  --light-green: #016040;
  --green: #006241;
  --black: #000;
  --white: #fff;
  --red: #c60c03;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
